import React from 'react';
import { useHistory } from 'react-router-dom';
import api from '../apis/api';
import style from './stylesheets/cartbox.module.css';

const Checkoutcart = (props) => {
    const history = useHistory();

    const delItem = async (e) => {
        console.log(e.target.value);
        try {
            await api.get('/delitem', { params: e.target.value });
            window.location.reload();

        } catch (error) {
            console.log(error);
        }
    }
    const chooseSize = (e) =>{
        let str = e.target.value;
        let size = str.substr(str.lastIndexOf('-')+1);
        let id = str.substr(0, str.lastIndexOf('-')); 
        // console.log('str ='+str);
        // console.log('size ='+size);
        // console.log('id ='+id);
        // let id = str.subst
        history.push('/checkout',{id:id,size:size});
    }

    return (
        <section className={style.ccart}>
            <div className={style.img}>
                <img src={`data:${props.contentType};base64,${props.imageBase64}`} alt="productImage" />
            </div>
            <div className={style.info}>
                <h3 style={{color:'darkblue'}}>{props.productName}</h3>
                <p style={{fontSize:'1.2rem'}}>₹ {props.discountAmount} <del style={{color:'red'}}>{props.amount}</del></p>
                <div className={style.size}>
                    <p>Size</p>
                    {props.size !== null ?
                        <select name="size" defaultValue={props._id+'-na'} onChange={chooseSize}>
                            <option>Select your size</option>
                            {
                                props.size.map((val) => {
                                    return (
                                        <option value={props._id+'-'+val}>{val}</option>
                                    )
                                })
                            }
                        </select> :<p style={{color:'green'}}>Not Available,Don't worry seller will contact you after placing order.</p>
                    }

                </div>
                <button value={props._id} onClick={delItem} className={style.btn}>Remove item</button>
                <br />
                <br />
                <p><strong>Delivery by </strong><br /> Tommorow </p>
            </div>

        </section>
    )
}

export default Checkoutcart;
